'use-strict'

import { absoluteOffset } from "../utilities/utilities";

function parallaxEvent() {

	const parallaxes = document.querySelectorAll('.parallax');

	parallaxes.forEach(function(element) {

		const elementOffset = absoluteOffset(element);
		const elementHeight = element.offsetHeight;
		const middleOffset = elementOffset.top + elementHeight / 2;
		const middleViewport = window.scrollY + window.visualViewport.height / 2

		if ( middleOffset > window.scrollY - 500 && middleOffset < window.scrollY + window.visualViewport.height + 500 ) {

			const layers = element.querySelectorAll('.parallax__layer');
			
			layers.forEach(function(layer) {

				let position = (elementHeight - layer.offsetHeight) / 2;
				let speed = +layer.getAttribute('data-parallax-speed') / 100;
				position = position + (middleOffset - middleViewport) * speed;

				layer.style.top = position + 'px';

			});

		}

	});

}

export {
	parallaxEvent,
};